import { isDefined } from "@clipboard-health/util-ts";
import { PlacementApplicationWithDetails } from "@src/appV2/PlacementApplications/api/useFetchPaginatedPlacementApplications";
import { PlacementApplicationStatusChip } from "@src/appV2/PlacementApplications/components/PlacementApplicationStatusChip";
import { usePlacementApplicationStatus } from "@src/appV2/PlacementApplications/hooks/usePlacementApplicationStatus";

export interface PlacementChannelStatusChipProps {
  channelUrl?: string;
  placementApplication?: PlacementApplicationWithDetails;
}

export function PlacementChannelStatusChip(props: PlacementChannelStatusChipProps) {
  const { channelUrl, placementApplication } = props;

  const { status } = usePlacementApplicationStatus({
    placementApplication,
    channelUrl,
  });

  if (!isDefined(channelUrl) && !isDefined(placementApplication)) {
    return null;
  }

  if (!isDefined(status)) {
    return null;
  }

  return <PlacementApplicationStatusChip status={status} />;
}
